var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "basic-container",
    [
      _c(
        "div",
        { staticClass: "search_group" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                "label-width": "120px",
                inline: "",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "手机号：" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: 100, placeholder: "手机号" },
                    model: {
                      value: _vm.form.phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "phone", $$v)
                      },
                      expression: "form.phone",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "用户uuid：" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: 100, placeholder: "用户uuid" },
                    model: {
                      value: _vm.form.leboUuid,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "leboUuid", $$v)
                      },
                      expression: "form.leboUuid",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "设备uid：" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: 100, placeholder: "设备uid" },
                    model: {
                      value: _vm.form.sdkUserId,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "sdkUserId", $$v)
                      },
                      expression: "form.sdkUserId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "投屏码：" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: 100, placeholder: "投屏码" },
                    model: {
                      value: _vm.form.groupNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "groupNumber", $$v)
                      },
                      expression: "form.groupNumber",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "mac地址：" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: 100, placeholder: "mac地址" },
                    model: {
                      value: _vm.form.mac,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "mac", $$v)
                      },
                      expression: "form.mac",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "IP地址：" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: 100, placeholder: "IP地址" },
                    model: {
                      value: _vm.form.ip,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "ip", $$v)
                      },
                      expression: "form.ip",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "时间范围" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      "value-format": "yyyyMMdd",
                      type: "daterange",
                      "start-placeholder": "开始时间",
                      "end-placeholder": "结束时间",
                    },
                    model: {
                      value: _vm.form.searchTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "searchTime", $$v)
                      },
                      expression: "form.searchTime",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.selectData },
                    },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          _vm.form = {}
                        },
                      },
                    },
                    [_vm._v("清空")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticStyle: { "margin-left": "50px" },
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.exportList },
            },
            [_vm._v("\n      导出")]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticClass: "table",
          attrs: { "element-loading-text": "加载中" },
        },
        [
          _c("avue-crud", {
            ref: "crud",
            attrs: {
              option: _vm.avueOption,
              "table-loading": _vm.loading,
              data: _vm.tableData,
              page: _vm.page,
            },
            on: {
              "update:page": function ($event) {
                _vm.page = $event
              },
              "on-load": _vm.getList,
              "refresh-change": _vm.onLoad,
            },
            scopedSlots: _vm._u([
              {
                key: "receiverCastServerTimestamp",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.dateFormatFn(
                            new Date(+scope.row.receiverCastServerTimestamp)
                          )
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
              {
                key: "menu",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.showFreeDetailFn(scope.row)
                          },
                        },
                      },
                      [_vm._v("详情")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "详情",
            visible: _vm.showFreeDetail,
            "append-to-body": "",
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showFreeDetail = $event
            },
          },
        },
        [
          _c("div", { staticClass: "dialog_box" }, [
            _c("div", { staticClass: "dialog_title" }, [
              _c("span", [_vm._v("投屏时间")]),
              _c("span", [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.dateFormatFn(
                        new Date(+_vm.dialogData.clientCastLocalTimestamp)
                      )
                    )
                ),
              ]),
            ]),
            _c("div", { staticClass: "fole_name" }, [_vm._v("发送端信息")]),
            _c("ul", [
              _c("li", [
                _c("div", { staticClass: "_row_name" }, [_vm._v("手机号")]),
                _c("div", { staticClass: "_row_text" }, [
                  _vm._v(_vm._s(_vm.dialogData.clientMobilePhone)),
                ]),
                _c("div", { staticClass: "_row_name" }, [_vm._v("用户uuid")]),
                _c("div", { staticClass: "_row_text" }, [
                  _vm._v(_vm._s(_vm.dialogData.clientLeboUuid)),
                ]),
              ]),
              _c("li", [
                _c("div", { staticClass: "_row_name" }, [
                  _vm._v("设备id（cu）"),
                ]),
                _c("div", { staticClass: "_row_text" }, [
                  _vm._v(_vm._s(_vm.dialogData.clientSdkUserId)),
                ]),
                _c("div", { staticClass: "_row_name" }, [
                  _vm._v("渠道名称+appid"),
                ]),
                _c("div", { staticClass: "_row_text" }, [
                  _vm._v(_vm._s(_vm.dialogData.clientSdkChannelName)),
                ]),
              ]),
              _c("li", [
                _c("div", { staticClass: "_row_name" }, [_vm._v("SDK版本")]),
                _c("div", { staticClass: "_row_text" }, [
                  _vm._v(_vm._s(_vm.dialogData.clientSdkVersion)),
                ]),
                _c("div", { staticClass: "_row_name" }, [_vm._v("imei")]),
                _c("div", { staticClass: "_row_text" }, [
                  _vm._v(_vm._s(_vm.dialogData.clientImei)),
                ]),
              ]),
              _c("li", [
                _c("div", { staticClass: "_row_name" }, [_vm._v("IDFA")]),
                _c("div", { staticClass: "_row_text" }, [
                  _vm._v(_vm._s(_vm.dialogData.clientIdfa)),
                ]),
                _c("div", { staticClass: "_row_name" }, [_vm._v("平台类型")]),
                _c("div", { staticClass: "_row_text" }, [
                  _vm._v(_vm._s(_vm.dialogData.clientPlatformType)),
                ]),
              ]),
              _c("li", [
                _c("div", { staticClass: "_row_name" }, [_vm._v("设备类型")]),
                _c("div", { staticClass: "_row_text" }, [
                  _vm._v(_vm._s(_vm.dialogData.clientBusinessType)),
                ]),
                _c("div", { staticClass: "_row_name" }, [_vm._v("设备品牌")]),
                _c("div", { staticClass: "_row_text" }, [
                  _vm._v(_vm._s(_vm.dialogData.clientDeviceBrand)),
                ]),
              ]),
              _c("li", [
                _c("div", { staticClass: "_row_name" }, [_vm._v("设备型号")]),
                _c("div", { staticClass: "_row_text" }, [
                  _vm._v(_vm._s(_vm.dialogData.clientDeviceModel)),
                ]),
                _c("div", { staticClass: "_row_name" }, [_vm._v("所在省市")]),
                _c("div", { staticClass: "_row_text" }, [
                  _vm._v(_vm._s(_vm.dialogData.clientIpCode)),
                ]),
              ]),
              _c("li", [
                _c("div", { staticClass: "_row_name" }, [_vm._v("IP地址")]),
                _c("div", { staticClass: "_row_text" }, [
                  _vm._v(_vm._s(_vm.dialogData.clientIp)),
                ]),
                _c("div", { staticClass: "_row_name" }, [_vm._v("MAC地址")]),
                _c("div", { staticClass: "_row_text" }, [
                  _vm._v(_vm._s(_vm.dialogData.mac)),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "fole_name" }, [_vm._v("接收端信息")]),
            _c("ul", [
              _c("li", [
                _c("div", { staticClass: "_row_name" }, [_vm._v("手机号")]),
                _c("div", { staticClass: "_row_text" }, [
                  _vm._v(_vm._s(_vm.dialogData.receiverMobilePhone)),
                ]),
                _c("div", { staticClass: "_row_name" }, [_vm._v("用户uuid")]),
                _c("div", { staticClass: "_row_text" }, [
                  _vm._v(_vm._s(_vm.dialogData.receiverLeboUuid)),
                ]),
              ]),
              _c("li", [
                _c("div", { staticClass: "_row_name" }, [
                  _vm._v("设备id（cu）"),
                ]),
                _c("div", { staticClass: "_row_text" }, [
                  _vm._v(_vm._s(_vm.dialogData.receiverSdkUserId)),
                ]),
                _c("div", { staticClass: "_row_name" }, [
                  _vm._v("渠道名称+appid"),
                ]),
                _c("div", { staticClass: "_row_text" }, [
                  _vm._v(_vm._s(_vm.dialogData.receiverSdkChannelName)),
                ]),
              ]),
              _c("li", [
                _c("div", { staticClass: "_row_name" }, [_vm._v("SDK版本")]),
                _c("div", { staticClass: "_row_text" }, [
                  _vm._v(_vm._s(_vm.dialogData.receiverSdkVersion)),
                ]),
                _c("div", { staticClass: "_row_name" }, [_vm._v("平台类型")]),
                _c("div", { staticClass: "_row_text" }, [
                  _vm._v(_vm._s(_vm.dialogData.receiverPlatformType)),
                ]),
              ]),
              _c("li", [
                _c("div", { staticClass: "_row_name" }, [_vm._v("设备类型")]),
                _c("div", { staticClass: "_row_text" }, [
                  _vm._v(_vm._s(_vm.dialogData.receiverBusinessType)),
                ]),
                _c("div", { staticClass: "_row_name" }, [_vm._v("设备品牌")]),
                _c("div", { staticClass: "_row_text" }, [
                  _vm._v(_vm._s(_vm.dialogData.receiverDeviceBrand)),
                ]),
              ]),
              _c("li", [
                _c("div", { staticClass: "_row_name" }, [_vm._v("设备型号")]),
                _c("div", { staticClass: "_row_text" }, [
                  _vm._v(_vm._s(_vm.dialogData.receiverDeviceModel)),
                ]),
                _c("div", { staticClass: "_row_name" }, [_vm._v("所在省市")]),
                _c("div", { staticClass: "_row_text" }, [
                  _vm._v(_vm._s(_vm.dialogData.receiverIpCode)),
                ]),
              ]),
              _c("li", [
                _c("div", { staticClass: "_row_name" }, [_vm._v("IP地址")]),
                _c("div", { staticClass: "_row_text" }, [
                  _vm._v(_vm._s(_vm.dialogData.receiverIp)),
                ]),
                _c("div", { staticClass: "_row_name" }, [_vm._v("MAC地址")]),
                _c("div", { staticClass: "_row_text" }, [
                  _vm._v(_vm._s(_vm.dialogData.receiverDeviceMac)),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }